import { REQUEST_TYPES } from '.';

export const getAllAgenciesRequest = () => ({
  type: `[API] Get All Agencies`,
  url: '/agency/list',
  APIMethod: REQUEST_TYPES.GET,
});

export const getAllAppsRequest = () => ({
  type: `[API] Get All Applications`,
  url: '/agency/app/all',
  APIMethod: REQUEST_TYPES.GET,
});

export const getMyAppsRequest = (headers) => ({
  type: `[API] Get My Apps`,
  url: '/agency/app/my',
  headers,
  APIMethod: REQUEST_TYPES.GET,
});

export const getMySecurityDevicesRequest = (headers) => ({
  type: `[API] Get My Security Devices`,
  url: '/user/security/advanced/devices',
  headers,
  APIMethod: REQUEST_TYPES.GET,
});

export const getMySecurityInitiateRequest = body => ({
  type: `[API] Initiate a Security Device`,
  url: '/user/security/advanced/device/register/initiate',
  APIMethod: REQUEST_TYPES.POST,
  body,
});
export const getMySecurityCompleteRequest = body => ({
  type: `[API] Complete a Security Device`,
  url: '/user/security/advanced/device/register/complete',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const deleteSecurityDeviceRequest = deviceUuid => ({
  type: `[API] Delete Security Device`,
  url: `/user/security/advanced/device/delete/${deviceUuid}`,
  APIMethod: REQUEST_TYPES.GET,
});

export const getMyAppsDataRequest = body => ({
  type: `[API] Get my Apps data`,
  url: '/app/ssao/getAppOnboardingData',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const getMyAppsDataRequestByAppId = body => ({
  type: `[API] Get my Apps data`,
  url: '/app/ssao/getAppOnboardingData',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const lookupAppLinkRequest = body => ({
  type: `[API] Lookup App Link`,
  url: '/agency/app/lookup',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const preLookupAppLinkRequest = body => ({
  type: `[API] Pre Lookup App Link`,
  url: '/agency/app/preLookup',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const verifyAppLinkRequest = body => ({
  type: `[API] Verify App Link`,
  url: '/agency/app/verify',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const unlinkAppLinkRequest = body => ({
  type: `[API] Unlink App Link`,
  url: '/agency/app/unlink',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const getAppParamsRequest = appId => ({
  type: `[API] Get App Params`,
  url: `/agency/app/param/${appId}`,
  APIMethod: REQUEST_TYPES.GET,
});

export const linkAppLinkRequest = body => ({
  type: `[API] Link App Link`,
  url: '/agency/app/link',
  APIMethod: REQUEST_TYPES.POST,
  body,
});
